import * as React from 'react';

function IconStatusInfoLarge(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M16 5C13.7255 5 11.5021 5.67446 9.61094 6.9381C7.71977 8.20174 6.24579 9.99779 5.37538 12.0991C4.50498 14.2005 4.27724 16.5128 4.72097 18.7435C5.1647 20.9743 6.25997 23.0234 7.86827 24.6317C9.47657 26.24 11.5257 27.3353 13.7565 27.779C15.9872 28.2228 18.2995 27.995 20.4009 27.1246C22.5022 26.2542 24.2983 24.7802 25.5619 22.8891C26.8255 20.9979 27.5 18.7745 27.5 16.5C27.5 13.45 26.2884 10.5249 24.1317 8.36827C21.9751 6.2116 19.05 5 16 5ZM18 24H14V17H12V15H18V24ZM16 13C15.6044 13 15.2178 12.8827 14.8889 12.6629C14.56 12.4432 14.3036 12.1308 14.1522 11.7654C14.0009 11.3999 13.9613 10.9978 14.0384 10.6098C14.1156 10.2219 14.3061 9.86549 14.5858 9.58579C14.8655 9.30608 15.2219 9.1156 15.6098 9.03843C15.9978 8.96126 16.3999 9.00087 16.7654 9.15224C17.1308 9.30362 17.4432 9.55996 17.6629 9.88886C17.8827 10.2178 18 10.6044 18 11C18 11.5304 17.7893 12.0391 17.4142 12.4142C17.0391 12.7893 16.5304 13 16 13Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconStatusInfoLarge;
